/**
 * JSX icon component rendering a named Heroicons-style SVG (20x20, currentColor).
 */
import { iconPaths, fallbackIcon } from '../lib/icon-paths.js';

export function Icon({ name, className = 'w-5 h-5 shrink-0' }) {
  const inner = iconPaths[name] || iconPaths[fallbackIcon];
  return (
    <svg
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: inner }}
    />
  );
}

// Ellipsis glyph used for context-menu buttons (not in the path registry).
export function EllipsisIcon({ className = 'w-4 h-4' }) {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" class={className} aria-hidden="true">
      <path d="M4 10a1.75 1.75 0 1 1 3.5 0A1.75 1.75 0 0 1 4 10Zm4.25 0a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Zm4.25 0a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z" />
    </svg>
  );
}

// Plus icon used by the compose attachment button.
export function PaperclipIcon({ className = 'w-5 h-5' }) {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" class={className} aria-hidden="true">
      <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" />
    </svg>
  );
}

// Send icon used by the compose send button.
export function SendIcon({ className = 'w-5 h-5' }) {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" class={className} aria-hidden="true">
      <path d="M6.3 2.84A1.5 1.5 0 0 0 4 4.11v11.78a1.5 1.5 0 0 0 2.3 1.27l9.344-5.891a1.5 1.5 0 0 0 0-2.538L6.3 2.841Z" />
    </svg>
  );
}

// Hamburger menu icon used by the mobile header.
export function MenuIcon({ className = 'w-5 h-5' }) {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" class={className} aria-hidden="true">
      <path fill-rule="evenodd" d="M2 4.75A.75.75 0 0 1 2.75 4h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 4.75Zm0 5a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 9.75Zm0 5a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 14.75Z" clip-rule="evenodd" />
    </svg>
  );
}